<template>
    <body class="">
        <!-- header -->
        <header id="header">
            <div class="container">
                <div class="nav">
                    <button class="btn btn-nav" @click="fn_gnbShow()">
                        <span class="blind">메뉴</span>
                    </button>
                    <button class="btn btn-back" @click="backbtn()">
                        <span class="blind">뒤로가기</span>
                    </button>
                </div>
                <div class="title">
                    <!-- <a ><img src="../assets/images/common/img_logo.png" alt=""></a> -->
                    <span>Face Mapping Registration</span>
                </div>
            </div>
        </header>
        <!-- // header -->

        <div id="content-wrap">
            <div id="contents">
                <!-- step info -->
                <div class="step-info-wrapper">
                    <div v-if="data.tunnelConstructionMethod === natm" class="container natm">
                        <ul>
                            <li @click="nextStep(data.tunnelConstructionMethod, 1)">
                                <span>STEP1.현장정보</span>
                            </li>
                            <li @click="nextStep(data.tunnelConstructionMethod, 2)">
                                <span>STEP2.이미지정보</span>
                            </li>
                            <li @click="nextStep(data.tunnelConstructionMethod, 3)">
                                <span>STEP3.막장 사진대지</span>
                            </li>
                            <li class="on" @click="nextStep(data.tunnelConstructionMethod, 4)">
                                <span>STEP4.강도정보</span>
                            </li>
                        </ul>
                    </div>
                    <div v-else class="container tbm">
                        <ul>
                            <li @click="nextStep(data.tunnelConstructionMethod, 1)">
                                <span>STEP1.현장정보</span>
                            </li>
                            <li @click="nextStep(data.tunnelConstructionMethod, 3)">
                                <span>STEP2.막장 사진대지</span>
                            </li>
                            <li class="on" @click="nextStep(data.tunnelConstructionMethod, 4)">
                                <span>STEP4.강도정보</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- // step info -->

                <!-- gnb -->
                <gnb :gnb-on="gnbShow" @getChildGnbShow="getChildGnbShow" />
                <div class="gnb-dimmed" :class="gnbShow" @click="getChildGnbShow()" />
                <!-- // gnb -->

                <!-- detail-wrapper -->
                <div class="detail-wrapper write-detail-wrapper">
                    <div class="detail-box":class="{ close: isCloseA }">
                        <div class="detail-header">
                            <a class="view" :class="{ close: !isCloseA }" @click="isCloseA = !isCloseA"><span>Face Mapping Note</span></a>
                        </div>
                        <div class="detail-contents">
                            <ul class="fms-note">
                                <li>
                                    <span>Construction Name</span>
                                    <span class="span-txt">{{ data.constructionNameValue }}</span>
                                </li>
                                <li>
                                    <span>Station(STA No.)</span>
                                    <span class="span-txt">{{ data.measureLocationName }} STA NO.{{ data.station }}</span>
                                </li>
                                <li>
                                    <span>Tunnel Construction Method</span>
                                    <span class="span-txt">{{ data.tunnelConstructionMethodName }}</span>
                                </li>
                                <li>
                                    <span>Geologist</span>
                                    <span class="span-txt">{{ data.geologist }}</span>
                                </li>
                                <li>
                                    <span>Rock Type</span>
                                    <span class="span-txt">{{ data.rockTypeName }}</span>
                                </li>
                                <li>
                                    <span>Date</span>
                                    <span class="span-txt">{{ data.investigationDay }} {{ data.investigationTime }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="detail-box" :class="{ close: isCloseB }">
                        <div class="detail-header">
                            <a class="view" :class="{ close: !isCloseB }" @click="isCloseB = !isCloseB"><span>Data Sheet</span></a>
                        </div>
                        <div class="detail-contents">
                            <div class="detail-subheader">
                                <h3>1. Rock Name</h3>
                                <div class="header-field-box select-box">
                                    <input v-show="data.faceMappingStrength.rockName ==='014004'" v-model="data.faceMappingStrength.rockNameEtc" type="text" class="txt type-1" style="right:212px;position: absolute" />
                                    <select v-model="data.faceMappingStrength.rockName" @change="changeRockName(data.faceMappingStrength.rockName)">
                                        <option
                                            v-for="(item, index) in rockNameList"
                                            :value="item.code"
                                        >
                                            {{ item.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="detail-subheader">
                                <h3>2. Strength of intact rock material(㎏/㎈)</h3>

                                <div class="header-field-box">
                                    <input v-model="data.faceMappingStrength.strengthIntackRockMaterial" type="text" class="txt type-1" />
                                    <input v-model="data.faceMappingStrength.strengthIntackRockMaterialScore" type="text" class="txt type-1" @keyup="countRmrScore()" />
                                </div>

                                <table class="type-simple">
                                    <thead>
                                        <tr>
                                            <th>>250</th>
                                            <th>~100</th>
                                            <th>~50</th>
                                            <th>~25</th>
                                            <th>~5</th>
                                            <th>~1</th>
                                            <th>&lt;1</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>15</td>
                                            <td>12</td>
                                            <td>7</td>
                                            <td>4</td>
                                            <td>2</td>
                                            <td>1</td>
                                            <td>0</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="detail-subheader">
                                <h3>3. R.Q.D(%)</h3>

                                <div class="header-field-box">
                                    <input v-model="data.faceMappingStrength.rqd" type="text" class="txt type-1" />
                                    <input v-model="data.faceMappingStrength.rqdScore" type="text" class="txt type-1" @keyup="countRmrScore()" />
                                </div>

                                <table class="type-simple">
                                    <thead>
                                        <tr>
                                            <th>90~100</th>
                                            <th>90~95</th>
                                            <th>75~50</th>
                                            <th>50~25</th>
                                            <th>&lt;25</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>15</td>
                                            <td>12</td>
                                            <td>7</td>
                                            <td>4</td>
                                            <td>2</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="detail-subheader">
                                <h3 style="text-decoration:underline" @click="resetSpacingOfJoint()">
                                    4. Spacing of Joint
                                </h3>

                                <div class="header-field-box single">
                                    <input v-model="data.faceMappingStrength.spacingJoinScore" type="text" class="txt" readonly @change="countRmrScore()" />
                                </div>

                                <table class="type-1">
                                    <colgroup>
                                        <col style="width: auto" />
                                        <col style="width: 65px" />
                                        <col style="width: 65px" />
                                        <col style="width: 65px" />
                                        <col style="width: 65px" />
                                        <col style="width: 65px" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>구분</th>
                                            <th>J1</th>
                                            <th>J2</th>
                                            <th>J3</th>
                                            <th>J4</th>
                                            <th>Ran</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                >2m <span class="sm">(20)</span>
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[0].spacingJoint" type="radio" class="rdo spacing_joint_area" name="J1_spacingJoint" data-key="20" value="2m" @change="changeSpacingOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[1].spacingJoint" type="radio" class="rdo spacing_joint_area" name="J2_spacingJoint" data-key="20" value="2m" @change="changeSpacingOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[2].spacingJoint" type="radio" class="rdo spacing_joint_area" name="J3_spacingJoint" data-key="20" value="2m" @change="changeSpacingOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[3].spacingJoint" type="radio" class="rdo spacing_joint_area" name="J4_spacingJoint" data-key="20" value="2m" @change="changeSpacingOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[4].spacingJoint" type="radio" class="rdo spacing_joint_area" name="Ran_spacingJoint" data-key="20" value="2m" @change="changeSpacingOfJoint()" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                0.6-2m <span class="sm">(15)</span>
                                            </td>
                                            <td>
                                                <input
                                                    v-model="data.faceMappingSectionList[0].spacingJoint"
                                                    type="radio"
                                                    class="rdo spacing_joint_area"
                                                    data-key="15"
                                                    name="J1_spacingJoint"
                                                    value="06-2m"
                                                    @change="changeSpacingOfJoint()"
                                                />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[1].spacingJoint" type="radio" class="rdo spacing_joint_area" name="J2_spacingJoint" value="06-2m" data-key="15" @change="changeSpacingOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[2].spacingJoint" type="radio" class="rdo spacing_joint_area" name="J3_spacingJoint" value="06-2m" data-key="15" @change="changeSpacingOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[3].spacingJoint" type="radio" class="rdo spacing_joint_area" name="J4_spacingJoint" value="06-2m" data-key="15" @change="changeSpacingOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[4].spacingJoint" type="radio" class="rdo spacing_joint_area" name="Ran_spacingJoint" value="06-2m" data-key="15" @change="changeSpacingOfJoint()" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                200-600m <span class="sm">(10)</span>
                                            </td>
                                            <td>
                                                <input
                                                    v-model="data.faceMappingSectionList[0].spacingJoint"
                                                    type="radio"
                                                    class="rdo spacing_joint_area"
                                                    data-key="10"
                                                    name="J1_spacingJoint"
                                                    value="200-600㎜"
                                                    @change="changeSpacingOfJoint()"
                                                />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[1].spacingJoint" type="radio" class="rdo spacing_joint_area"name="J2_spacingJoint" value="200-600㎜" data-key="10" @change="changeSpacingOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[2].spacingJoint" type="radio" class="rdo spacing_joint_area" name="J3_spacingJoint" value="200-600㎜" data-key="10" @change="changeSpacingOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[3].spacingJoint" type="radio" class="rdo spacing_joint_area"name="J4_spacingJoint" value="200-600㎜" data-key="10" @change="changeSpacingOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[4].spacingJoint" type="radio" class="rdo spacing_joint_area"name="Ran_spacingJoint" value="200-600㎜" data-key="10" @change="changeSpacingOfJoint()" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                60-200mm <span class="sm">(8)</span>
                                            </td>
                                            <td>
                                                <input
                                                    v-model="data.faceMappingSectionList[0].spacingJoint"
                                                    type="radio"
                                                    class="rdo spacing_joint_area"
                                                    data-key="8"
                                                    name="J1_spacingJoint"
                                                    value="60-200㎜"
                                                    @change="changeSpacingOfJoint()"
                                                />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[1].spacingJoint" type="radio" class="rdo spacing_joint_area"name="J2_spacingJoint" value="60-200㎜" data-key="8" @change="changeSpacingOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[2].spacingJoint" type="radio" class="rdo spacing_joint_area"name="J3_spacingJoint" value="60-200㎜" data-key="8" @change="changeSpacingOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[3].spacingJoint" type="radio" class="rdo spacing_joint_area"name="J4_spacingJoint" value="60-200㎜" data-key="8" @change="changeSpacingOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[4].spacingJoint" type="radio" class="rdo spacing_joint_area"name="Ran_spacingJoint" value="60-200㎜" data-key="8" @change="changeSpacingOfJoint()" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                &lt;60mm <span class="sm">(6)</span>
                                            </td>
                                            <td>
                                                <input
                                                    v-model="data.faceMappingSectionList[0].spacingJoint"
                                                    type="radio"
                                                    class="rdo spacing_joint_area"
                                                    data-key="6"
                                                    name="J1_spacingJoint"
                                                    value="60㎜"
                                                    @change="changeSpacingOfJoint()"
                                                />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[1].spacingJoint" type="radio" class="rdo spacing_joint_area" name="J2_spacingJoint" value="60㎜" data-key="6" @change="changeSpacingOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[2].spacingJoint" type="radio" class="rdo spacing_joint_area" name="J3_spacingJoint" value="60㎜" data-key="6" @change="changeSpacingOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[3].spacingJoint" type="radio" class="rdo spacing_joint_area" name="J4_spacingJoint" value="60㎜" data-key="6" @change="changeSpacingOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[4].spacingJoint" type="radio" class="rdo spacing_joint_area" name="Ran_spacingJoint" value="60㎜" data-key="6" @change="changeSpacingOfJoint()" />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="detail-subheader">
                                <h3>5. Condition of Joint</h3>

                                <div class="header-field-box single">
                                    <input v-model="data.faceMappingStrength.conditionJoinScore" type="text" class="txt" readonly @change="countRmrScore()" />
                                </div>

                                <table class="type-1">
                                    <colgroup>
                                        <col style="width: 124px" />
                                        <col style="width: 47.64%" />
                                        <col style="width: 65px" />
                                        <col style="width: 65px" />
                                        <col style="width: 65px" />
                                        <col style="width: 65px" />
                                        <col style="width: 65px" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th colspan="2">
                                                구분
                                            </th>
                                            <th>J1</th>
                                            <th>J2</th>
                                            <th>J3</th>
                                            <th>J4</th>
                                            <th>Ran</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td rowspan="5" style="text-decoration:underline" @click="resetPersistence()">
                                                Persistence
                                            </td>
                                            <td>
                                                &lt;1m <span class="sm">(6)</span>
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[0].persitence" type="radio" class="rdo persistence_area" data-key="6" name="J1_persitence" value="1m" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[1].persitence" type="radio" class="rdo persistence_area" data-key="6" name="J2_persitence" value="1m" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[2].persitence" type="radio" class="rdo persistence_area" data-key="6" name="J3_persitence" value="1m" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[3].persitence" type="radio"class="rdo persistence_area" data-key="6" name="J4_persitence" value="1m" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[4].persitence" type="radio" class="rdo persistence_area" data-key="6" name="Ran_persitence" value="1m" @change="changeConditionOfJoint()" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                1-3m <span class="sm">(4)</span>
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[0].persitence" type="radio" class="rdo persistence_area" data-key="4" name="J1_persitence" value="1-3m" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[1].persitence" type="radio" class="rdo persistence_area" data-key="4" name="J2_persitence" value="1-3m" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[2].persitence" type="radio" class="rdo persistence_area" data-key="4" name="J3_persitence" value="1-3m" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[3].persitence" type="radio" class="rdo persistence_area" data-key="4" name="J4_persitence" value="1-3m" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[4].persitence" type="radio" class="rdo persistence_area" data-key="4" name="Ran_persitence" value="1-3m" @change="changeConditionOfJoint()" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                3-10m <span class="sm">(2)</span>
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[0].persitence"type="radio" class="rdo persistence_area" data-key="2" name="J1_persitence" value="3-10m" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[1].persitence"type="radio" class="rdo persistence_area" data-key="2" name="J2_persitence" value="3-10m" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[2].persitence"type="radio" class="rdo persistence_area" data-key="2" name="J3_persitence" value="3-10m" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[3].persitence"type="radio" class="rdo persistence_area" data-key="2" name="J4_persitence" value="3-10m" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[4].persitence"type="radio" class="rdo persistence_area" data-key="2" name="Ran_persitence" value="3-10m" @change="changeConditionOfJoint()" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                10-20m <span class="sm">(1)</span>
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[0].persitence" type="radio" class="rdo persistence_area" data-key="1" name="J1_persitence" value="10-20m" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[1].persitence"type="radio" class="rdo persistence_area" data-key="1" name="J2_persitence" value="10-20m" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[2].persitence"type="radio" class="rdo persistence_area" data-key="1" name="J3_persitence" value="10-20m" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[3].persitence"type="radio" class="rdo persistence_area" data-key="1" name="J4_persitence" value="10-20m" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[4].persitence"type="radio" class="rdo persistence_area" data-key="1" name="Ran_persitence" value="10-20m" @change="changeConditionOfJoint()" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                &gt;20mm <span class="sm">(0)</span>
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[0].persitence"type="radio" class="rdo persistence_area" data-key="0" name="J1_persitence" value="20m" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[1].persitence"type="radio" class="rdo persistence_area" data-key="0" name="J2_persitence" value="20m" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[2].persitence"type="radio" class="rdo persistence_area" data-key="0" name="J3_persitence" value="20m" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[3].persitence" type="radio"class="rdo persistence_area" data-key="0" name="J4_persitence" value="20m" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[4].persitence"type="radio" class="rdo persistence_area" data-key="0" name="Ran_persitence" value="20m" @change="changeConditionOfJoint()" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td rowspan="5" style="text-decoration:underline" @click="resetAperture()">
                                                Aperture
                                            </td>
                                            <td>
                                                None <span class="sm">(6)</span>
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[0].aperture"type="radio" class="rdo aperture_area" data-key="6"name="J1_aperture" value="None" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[1].aperture"type="radio" class="rdo aperture_area" data-key="6"name="J2_aperture" value="None" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[2].aperture"type="radio" class="rdo aperture_area" data-key="6"name="J3_aperture" value="None" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[3].aperture"type="radio" class="rdo aperture_area" data-key="6"name="J4_aperture" value="None" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[4].aperture"type="radio" class="rdo aperture_area" data-key="6"name="Ran_aperture" value="None" @change="changeConditionOfJoint()" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                &lt;0.1mm <span class="sm">(5)</span>
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[0].aperture"type="radio" class="rdo aperture_area" data-key="5"name="J1_aperture" value="01㎜" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[1].aperture" type="radio" class="rdo aperture_area" data-key="5"name="J2_aperture" value="01㎜" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[2].aperture"type="radio" class="rdo aperture_area" data-key="5"name="J3_aperture" value="01㎜" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[3].aperture" type="radio" class="rdo aperture_area" data-key="5"name="J4_aperture" value="01㎜" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[4].aperture"type="radio" class="rdo aperture_area" data-key="5"name="Ran_aperture" value="01㎜" @change="changeConditionOfJoint()" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                0.1m-1mm <span class="sm">(4)</span>
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[0].aperture"type="radio" class="rdo aperture_area" data-key="4" name="J1_aperture" value="01-1㎜" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[1].aperture"type="radio" class="rdo aperture_area" data-key="4" name="J2_aperture" value="01-1㎜" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[2].aperture"type="radio" class="rdo aperture_area" data-key="4" name="J3_aperture" value="01-1㎜" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[3].aperture"type="radio" class="rdo aperture_area" data-key="4" name="J4_aperture" value="01-1㎜" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[4].aperture"type="radio" class="rdo aperture_area" data-key="4" name="Ran_aperture" value="01-1㎜" @change="changeConditionOfJoint()" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                1-5m <span class="sm">(1)</span>
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[0].aperture" type="radio" class="rdo aperture_area" data-key="1" name="J1_aperture" value="1-5㎜" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[1].aperture"type="radio" class="rdo aperture_area" data-key="1" name="J2_aperture" value="1-5㎜" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[2].aperture" type="radio" class="rdo aperture_area" data-key="1" name="J3_aperture" value="1-5㎜" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[3].aperture"type="radio" class="rdo aperture_area" data-key="1" name="J4_aperture" value="1-5㎜" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[4].aperture" type="radio" class="rdo aperture_area" data-key="1" name="Ran_aperture" value="1-5㎜" @change="changeConditionOfJoint()" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                &gt;5mm <span class="sm">(0)</span>
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[0].aperture"type="radio" class="rdo aperture_area" data-key="0" name="J1_aperture" value="5㎜" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[1].aperture"type="radio" class="rdo aperture_area" data-key="0" name="J2_aperture" value="5㎜" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[2].aperture"type="radio" class="rdo aperture_area" data-key="0" name="J3_aperture" value="5㎜" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[3].aperture"type="radio" class="rdo aperture_area" data-key="0" name="J4_aperture" value="5㎜" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[4].aperture"type="radio" class="rdo aperture_area" data-key="0" name="Ran_aperture" value="5㎜" @change="changeConditionOfJoint()" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td rowspan="5" style="text-decoration:underline" @click="resetRoughness()">
                                                Roughness
                                            </td>
                                            <td>
                                                Very rough <span class="sm">(6)</span>
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[0].roughness"type="radio" class="rdo roughness_area" data-key="6" name="J1_roughness" value="Very_rough" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[1].roughness"type="radio" class="rdo roughness_area" data-key="6" name="J2_roughness" value="Very_rough" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[2].roughness"type="radio" class="rdo roughness_area" data-key="6" name="J3_roughness" value="Very_rough" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[3].roughness"type="radio" class="rdo roughness_area" data-key="6" name="J4_roughness" value="Very_rough" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[4].roughness"type="radio" class="rdo roughness_area" data-key="6" name="Ran_roughness" value="Very_rough" @change="changeConditionOfJoint()" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Rough <span class="sm">(5)</span>
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[0].roughness"type="radio" class="rdo roughness_area" data-key="5" name="J1_roughness" value="rough" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[1].roughness"type="radio" class="rdo roughness_area" data-key="5" name="J2_roughness" value="rough" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[2].roughness"type="radio" class="rdo roughness_area" data-key="5" name="J3_roughness" value="rough" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[3].roughness"type="radio" class="rdo roughness_area" data-key="5" name="J4_roughness" value="rough" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[4].roughness"type="radio" class="rdo roughness_area" data-key="5" name="Ran_roughness" value="rough" @change="changeConditionOfJoint()" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Slightly Rough <span class="sm">(3)</span>
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[0].roughness"type="radio" class="rdo roughness_area" data-key="3" name="J1_roughness" value="slightly_rough" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[1].roughness"type="radio" class="rdo roughness_area" data-key="3" name="J2_roughness" value="slightly_rough" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[2].roughness"type="radio" class="rdo roughness_area" data-key="3" name="J3_roughness" value="slightly_rough" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[3].roughness"type="radio" class="rdo roughness_area" data-key="3" name="J4_roughness" value="slightly_rough" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[4].roughness"type="radio" class="rdo roughness_area" data-key="3" name="Ran_roughness" value="slightly_rough" @change="changeConditionOfJoint()" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Smooth <span class="sm">(1)</span>
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[0].roughness"type="radio" class="rdo roughness_area" data-key="1" name="J1_roughness" value="Smooth" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[1].roughness"type="radio" class="rdo roughness_area" data-key="1" name="J2_roughness" value="Smooth" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[2].roughness"type="radio" class="rdo roughness_area" data-key="1" name="J3_roughness" value="Smooth" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[3].roughness"type="radio" class="rdo roughness_area" data-key="1" name="J4_roughness" value="Smooth" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[4].roughness" type="radio"class="rdo roughness_area" data-key="1" name="Ran_roughness" value="Smooth" @change="changeConditionOfJoint()" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Slickenside <span class="sm">(0)</span>
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[0].roughness"type="radio" class="rdo roughness_area" data-key="0" name="J1_roughness" value="slickenside" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[1].roughness"type="radio" class="rdo roughness_area" data-key="0" name="J2_roughness" value="slickenside" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[2].roughness"type="radio" class="rdo roughness_area" data-key="0" name="J3_roughness" value="slickenside" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[3].roughness"type="radio" class="rdo roughness_area" data-key="0" name="J4_roughness" value="slickenside" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[4].roughness"type="radio" class="rdo roughness_area" data-key="0" name="Ran_roughness" value="slickenside" @change="changeConditionOfJoint()" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td rowspan="5" style="text-decoration:underline" @click="resetFilling()">
                                                In-Filling
                                            </td>
                                            <td>
                                                None <span class="sm">(6)</span>
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[0].inFilling"type="radio" class="rdo filling_area" data-key="6" name="J1_inFilling" value="None" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[1].inFilling"type="radio" class="rdo filling_area" data-key="6" name="J2_inFilling" value="None" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[2].inFilling"type="radio" class="rdo filling_area" data-key="6" name="J3_inFilling" value="None" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[3].inFilling"type="radio" class="rdo filling_area" data-key="6" name="J4_inFilling" value="None" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[4].inFilling"type="radio" class="rdo filling_area" data-key="6" name="Ran_inFilling" value="None" @change="changeConditionOfJoint()" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Hardfilling
                                                < 5㎜ <span class="sm">(4)</span>
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[0].inFilling"type="radio" class="rdo filling_area" data-key="4" name="J1_inFilling" value="hardfilling_5㎜_below" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[1].inFilling"type="radio" class="rdo filling_area" data-key="4" name="J2_inFilling" value="hardfilling_5㎜_below" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[2].inFilling"type="radio" class="rdo filling_area" data-key="4" name="J3_inFilling" value="hardfilling_5㎜_below" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[3].inFilling"type="radio" class="rdo filling_area" data-key="4" name="J4_inFilling" value="hardfilling_5㎜_below" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[4].inFilling"type="radio" class="rdo filling_area" data-key="4" name="Ran_inFilling" value="hardfilling_5㎜_below" @change="changeConditionOfJoint()" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Hardfilling > 5㎜ <span class="sm">(2)</span>
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[0].inFilling"type="radio" class="rdo filling_area" data-key="2" name="J1_inFilling" value="hardfilling_5㎜_more" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[1].inFilling"type="radio" class="rdo filling_area" data-key="2" name="J2_inFilling" value="hardfilling_5㎜_more" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[2].inFilling"type="radio" class="rdo filling_area" data-key="2" name="J3_inFilling" value="hardfilling_5㎜_more" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[3].inFilling"type="radio" class="rdo filling_area" data-key="2" name="J4_inFilling" value="hardfilling_5㎜_more" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[4].inFilling"type="radio" class="rdo filling_area" data-key="2" name="Ran_inFilling" value="hardfilling_5㎜_more" @change="changeConditionOfJoint()" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Softfilling < 5㎜ <span class="sm">(2)</span>
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[0].inFilling"type="radio" class="rdo filling_area" data-key="2" name="J1_inFilling" value="softfilling_5㎜_below" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[1].inFilling"type="radio" class="rdo filling_area" data-key="2" name="J2_inFilling" value="softfilling_5㎜_below" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[2].inFilling"type="radio" class="rdo filling_area" data-key="2" name="J3_inFilling" value="softfilling_5㎜_below" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[3].inFilling"type="radio" class="rdo filling_area" data-key="2" name="J4_inFilling" value="softfilling_5㎜_below" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[4].inFilling"type="radio" class="rdo filling_area" data-key="2" name="Ran_inFilling" value="softfilling_5㎜_below" @change="changeConditionOfJoint()" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Softfilling > 5㎜ <span class="sm">(0)</span>
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[0].inFilling"type="radio" class="rdo filling_area" data-key="0" name="J1_inFilling" value="softfilling_5㎜_more" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[1].inFilling"type="radio" class="rdo filling_area" data-key="0" name="J2_inFilling" value="softfilling_5㎜_more" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[2].inFilling" type="radio"class="rdo filling_area" data-key="0" name="J3_inFilling" value="softfilling_5㎜_more" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[3].inFilling" type="radio"class="rdo filling_area" data-key="0" name="J4_inFilling" value="softfilling_5㎜_more" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[4].inFilling" type="radio"class="rdo filling_area" data-key="0" name="Ran_inFilling" value="softfilling_5㎜_more" @change="changeConditionOfJoint()" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td rowspan="5" @click="resetStrength()">
                                                Wall Strength
                                            </td>
                                            <td>
                                                Unweathered <span class="sm">(6)</span>
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[0].wallStrength"type="radio" class="rdo strength_area" data-key="6" name="J1_wallStrength" value="unweathered" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[1].wallStrength"type="radio" class="rdo strength_area" data-key="6" name="J2_wallStrength" value="unweathered" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[2].wallStrength" type="radio"class="rdo strength_area" data-key="6" name="J3_wallStrength" value="unweathered" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[3].wallStrength"type="radio" class="rdo strength_area" data-key="6" name="J4_wallStrength" value="unweathered" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[4].wallStrength"type="radio" class="rdo strength_area" data-key="6" name="Ran_wallStrength" value="unweathered" @change="changeConditionOfJoint()" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Slightly Weathered <span class="sm">(5)</span>
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[0].wallStrength"type="radio" class="rdo strength_area" data-key="5" name="J1_wallStrength" value="slightly_weathered" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[1].wallStrength"type="radio" class="rdo strength_area" data-key="5" name="J2_wallStrength" value="slightly_weathered" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[2].wallStrength"type="radio" class="rdo strength_area" data-key="5" name="J3_wallStrength" value="slightly_weathered" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[3].wallStrength"type="radio" class="rdo strength_area" data-key="5" name="J4_wallStrength" value="slightly_weathered" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[4].wallStrength" type="radio"class="rdo strength_area" data-key="5" name="Ran_wallStrength" value="slightly_weathered" @change="changeConditionOfJoint()" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Moderately Weathered <span class="sm">(3)</span>
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[0].wallStrength"type="radio" class="rdo strength_area" data-key="3" name="J1_wallStrength" value="moderately_weathered" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[1].wallStrength"type="radio" class="rdo strength_area" data-key="3" name="J2_wallStrength" value="moderately_weathered" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[2].wallStrength"type="radio" class="rdo strength_area" data-key="3" name="J3_wallStrength" value="moderately_weathered" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[3].wallStrength"type="radio" class="rdo strength_area" data-key="3" name="J4_wallStrength" value="moderately_weathered" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[4].wallStrength"type="radio" class="rdo strength_area" data-key="3" name="Ran_wallStrength" value="moderately_weathered" @change="changeConditionOfJoint()" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Highly Weathered <span class="sm">(1)</span>
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[0].wallStrength"type="radio" class="rdo strength_area" data-key="1" name="J1_wallStrength" value="highly_weathered" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[1].wallStrength"type="radio" class="rdo strength_area" data-key="1" name="J2_wallStrength" value="highly_weathered" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[2].wallStrength"type="radio" class="rdo strength_area" data-key="1" name="J3_wallStrength" value="highly_weathered" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[3].wallStrength"type="radio" class="rdo strength_area" data-key="1" name="J4_wallStrength" value="highly_weathered" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[4].wallStrength"type="radio" class="rdo strength_area" data-key="1" name="Ran_wallStrength" value="highly_weathered" @change="changeConditionOfJoint()" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Completely Weathered <span class="sm">(0)</span>
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[0].wallStrength"type="radio" class="rdo strength_area" data-key="0" name="J1_wallStrength" value="completely_weathered" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[1].wallStrength"type="radio" class="rdo strength_area" data-key="0" name="J2_wallStrength" value="completely_weathered" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[2].wallStrength"type="radio" class="rdo strength_area" data-key="0" name="J3_wallStrength" value="completely_weathered" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[3].wallStrength"type="radio" class="rdo strength_area" data-key="0" name="J4_wallStrength" value="completely_weathered" @change="changeConditionOfJoint()" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingSectionList[4].wallStrength"type="radio" class="rdo strength_area" data-key="0" name="Ran_wallStrength" value="completely_weathered" @change="changeConditionOfJoint()" />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="detail-subheader">
                                <h3>6. Ground water Ratio </h3>

                                <div class="header-field-box single">
                                    <input v-model="data.faceMappingStrength.groundWaterRatioScore" type="text" class="txt type-1" @keyup="countRmrScore()" />
                                </div>

                                <table class="type-1">
                                    <colgroup>
                                        <col style="width: 125px" />
                                        <col style="width: auto" />
                                        <col style="width: 125px" />
                                        <col style="width: 62px" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>Condition</th>
                                            <th>
                                                Inflow per 10m
                                                <br />tunnel length
                                            </th>
                                            <th>Rating</th>
                                            <th>Check</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Dry</td>
                                            <td>-</td>
                                            <td>15</td>
                                            <td>
                                                <input v-model="groundWaterRatioList" type="checkbox" class="chk" value="dry" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Damp</td>
                                            <td>
                                                <10
                                            </td>
                                            <td>10</td>
                                            <td>
                                                <input v-model="groundWaterRatioList" type="checkbox" class="chk" value="damp" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Wet</td>
                                            <td>10~25</td>
                                            <td>7</td>
                                            <td>
                                                <input v-model="groundWaterRatioList" type="checkbox" class="chk" value="wet" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Dripping</td>
                                            <td>25~125</td>
                                            <td>4</td>
                                            <td>
                                                <input v-model="groundWaterRatioList" type="checkbox" class="chk" value="dripping" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Flowing</td>
                                            <td>>125</td>
                                            <td>0</td>
                                            <td>
                                                <input v-model="groundWaterRatioList" type="checkbox" class="chk" value="flowing" />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="detail-subheader">
                                <h3>7. Ratio of adjustment for joint orientation</h3>

                                <table class="type-1 form-table">
                                    <colgroup>
                                        <col style="width: 125px" />
                                        <col style="width: auto" />
                                        <col style="width: 194px" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>구분</th>
                                            <th>Operation</th>
                                            <th>Rating</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Tunnel</td>
                                            <td />
                                            <td>
                                                <input v-model="data.faceMappingStrength.orientationScore" type="text" class="txt type-1 full" @keyup="countRmrScore()" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Joint1</td>
                                            <td>
                                                <input v-model="data.faceMappingStrength.orientationJoint1" type="text" class="txt full type-1" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingStrength.orientationJoint1Rating" type="text" class="txt full type-1" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Joint2</td>
                                            <td>
                                                <input v-model="data.faceMappingStrength.orientationJoint2" type="text" class="txt full type-1" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingStrength.orientationJoint2Rating" type="text" class="txt full type-1" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Joint3</td>
                                            <td>
                                                <input v-model="data.faceMappingStrength.orientationJoint3" type="text" class="txt full type-1" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingStrength.orientationJoint3Rating" type="text" class="txt full type-1" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Joint4</td>
                                            <td>
                                                <input v-model="data.faceMappingStrength.orientationJoint4" type="text" class="txt full type-1" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingStrength.orientationJoint4Rating" type="text" class="txt full type-1" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Random Joint</td>
                                            <td>
                                                <input v-model="data.faceMappingStrength.orientationRandomJoint" type="text" class="txt full type-1" />
                                            </td>
                                            <td>
                                                <input v-model="data.faceMappingStrength.orientationRandomJointRating" type="text" class="txt full type-1" />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div class="table-gap" />

                                <table class="type-2">
                                    <tr>
                                        <th class="tit">
                                            Very Favourable
                                        </th>
                                        <th class="tit">
                                            Favourable
                                        </th>
                                        <th class="tit">
                                            Fair
                                        </th>
                                        <th class="tit">
                                            Unfavourable
                                        </th>
                                        <th class="tit">
                                            Very Unfavourable
                                        </th>
                                    </tr>
                                    <tr>
                                        <td>0</td>
                                        <td>-2</td>
                                        <td>-5</td>
                                        <td>-10</td>
                                        <td>-12</td>
                                    </tr>
                                </table>

                                <div class="table-gap" />

                                <table class="type-2">
                                    <colgroup>
                                        <col style="width:45%" />
                                        <col style="width:55%" />
                                    </colgroup>
                                    <tr>
                                        <th colspan="2">
                                            Strike perpendicular to tunnel axis
                                        </th>
                                    </tr>
                                    <tr>
                                        <td class="align-left">
                                            Very Favourable
                                        </td>
                                        <td class="align-left">
                                            Drive with dip 45~90℃
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="align-left">
                                            Favourable
                                        </td>
                                        <td class="align-left">
                                            Drive with dip 20~45℃
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="align-left">
                                            Fair
                                        </td>
                                        <td class="align-left">
                                            Drive against dip-Dip 45~90℃
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="align-left">
                                            Unfavourable</th>
                                        </td><td class="align-left">
                                            Drive against dip-Dip 20~45℃
                                        </td>
                                    </tr>
                                </table>

                                <div class="table-gap" />

                                <table class="type-2">
                                    <colgroup>
                                        <col style="width:45%" />
                                        <col style="width:55%" />
                                    </colgroup>
                                    <tr>
                                        <th colspan="2" class="align-left">
                                            Strike parallel to tunnel axis
                                        </th>
                                    </tr>
                                    <tr>
                                        <td class="align-left">
                                            Very unfavourable
                                        </td>
                                        <td class="align-left">
                                            Dip 45~90℃
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="align-left">
                                            Fair
                                        </td>
                                        <td class="align-left">
                                            Dip 20~45℃
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="align-left">
                                            Fair
                                        </td>
                                        <td class="align-left">
                                            Dip 0~20℃ ~ irrespective of strike
                                        </td>
                                    </tr>
                                </table>
                            </div>

                            <div class="detail-subheader">
                                <h3>8. RMR Score</h3>
                                <div class="field-wrap">
                                    <input v-model="rmrScore" type="text" class="txt  full" readonly />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="btn-wrapper bottom-fixed">
                        <button type="button" class="btn btn-cancel" @click="prev(data.tunnelConstructionMethod, 3)">
                            <span>이전으로</span>
                        </button>
                        <button type="button" class="btn btn-next" @click="save()">
                            <span>저장</span>
                        </button>
                    </div>

                    <confirm :param="confirmParam" @confirmCallback="confirmCallback" />
                </div>
                <!-- // detail-wrapper -->
            </div>
        </div>
    </body>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import CodeApi from '../../api/CodeApi';
import FacemappingApi from '../../api/FacemappingApi';
import { COMM_CODE, TUNNEL_CONSTRUCTION } from './../../const';
import confirm from './../common/Confirm.vue';
import gnb from './../layout/gnb.vue';

export default {
    name: 'Step4',
    components: {
      gnb,
      confirm
    },
    data: () => {
        return {
            id: null,
            data: {},
            rockNameList : {},
            groundWaterRatioList : [],
            isCloseA: false,
            isCloseB: false,
            rmrScore : 0,
            gnbShow: '',
            confirmParam: {
                msg: '',
                isShow: false,
                callbackParam: {}
            },
            natm: TUNNEL_CONSTRUCTION.NATM
        };
    },
    computed: {
        ...mapState({
            stateData: state => {
                return JSON.parse(JSON.stringify(state.facemapping.data));
            }
        })
    },
    beforeCreate() {
        ///////////////////////
        // Initializer Area
        ///////////////////////
        //this.showLoading();
        //this.$store.dispatch('showLoading');
    },
    created() {
      this.id = this.$route.params.id;
      if (this.id != null) {
          this.dataObj();
      }
      if(this.data.faceMappingStrength == null){
        this.data.faceMappingStrength = {
          masterId:this.$route.params.id,
          strengthId:null,
          groundWaterRatio:'',
          rockName:'014001',
          conditionJoinScore:0,
          groundWaterRatioScore:0,
          orientationScore:0,
          rqdScore:0,
          spacingJoinScore:0,
          strengthIntackRockMaterialScore:0
        };
        this.data.faceMappingSectionList = [
          { aperture: "",id:{'masterId':this.$route.params.id,'sectionDivisionCd' : 'J1'},inFilling: "",persitence: "",roughness: "",spacingJoint: "",wallStrength: "" },
          { aperture: "",id:{'masterId':this.$route.params.id,'sectionDivisionCd' : 'J2'},inFilling: "",persitence: "",roughness: "",spacingJoint: "",wallStrength: "" },
          { aperture: "",id:{'masterId':this.$route.params.id,'sectionDivisionCd' : 'J3'},inFilling: "",persitence: "",roughness: "",spacingJoint: "",wallStrength: "" },
          { aperture: "",id:{'masterId':this.$route.params.id,'sectionDivisionCd' : 'J4'},inFilling: "",persitence: "",roughness: "",spacingJoint: "",wallStrength: "" },
          { aperture: "",id:{'masterId':this.$route.params.id,'sectionDivisionCd' : 'Ran'},inFilling: "",persitence: "",roughness: "",spacingJoint: "",wallStrength: "" }
        ];
      }

    },
    mounted() {
        //ScreenHelper.setPortrait();
        window.scrollTo(0, 0);
        this.id = this.$route.params.id;
        this.data.faceMappingStrength.masterId = this.$route.params.id;
        this.codeSettign(COMM_CODE.rockName);
        this.hideLoading();
    },
    beforeDestroy() {},
    methods: {
        ...mapActions(['showLoading', 'hideLoading','alert']),
        backbtn() {
            this.$router.go(-1);
        },
        fn_gnbShow() {
            this.gnbShow = 'on';
            $('html').addClass('off');
        },
        getChildGnbShow() {
            this.gnbShow = '';
            $('html').removeClass('off');
        },
        dataObj() {
            this.showLoading();
            var that = this;
            FacemappingApi.detail(this.id).then(res => {
                that.data = res.content;
                if(that.data.faceMappingStrength == null){
                  that.data.faceMappingStrength = {
                    masterId:that.$route.params.id,
                    strengthId:null,
                    groundWaterRatio:'',
                    rockName:'014001',
                    conditionJoinScore:0,
                    groundWaterRatioScore:0,
                    orientationScore:0,
                    rqdScore:0,
                    spacingJoinScore:0,
                    strengthIntackRockMaterialScore:0
                  };
                  that.data.faceMappingSectionList = [
                    { aperture: "",id:{'masterId':that.$route.params.id,'sectionDivisionCd' : 'J1'},inFilling: "",persitence: "",roughness: "",spacingJoint: "",wallStrength: "" },
                    { aperture: "",id:{'masterId':that.$route.params.id,'sectionDivisionCd' : 'J2'},inFilling: "",persitence: "",roughness: "",spacingJoint: "",wallStrength: "" },
                    { aperture: "",id:{'masterId':that.$route.params.id,'sectionDivisionCd' : 'J3'},inFilling: "",persitence: "",roughness: "",spacingJoint: "",wallStrength: "" },
                    { aperture: "",id:{'masterId':that.$route.params.id,'sectionDivisionCd' : 'J4'},inFilling: "",persitence: "",roughness: "",spacingJoint: "",wallStrength: "" },
                    { aperture: "",id:{'masterId':that.$route.params.id,'sectionDivisionCd' : 'Ran'},inFilling: "",persitence: "",roughness: "",spacingJoint: "",wallStrength: "" }
                  ];
                }else{
                  if(that.data.faceMappingStrength.groundWaterRatio != null) that.groundWaterRatioList = that.data.faceMappingStrength.groundWaterRatio.split(",");
                }

                that.countRmrScore();
                that.hideLoading();
            });
        },
        nextStep(tunnelConstructionMethod, step) {
            if (step == 4) return;

             if(step == 3){
              if (tunnelConstructionMethod == TUNNEL_CONSTRUCTION.NATM)
                  this.$router.push({ path: `/step` + step + `/${this.data.id}` });
              else this.$router.push({ path: `/step` + step + `TBM/${this.data.id}` });
            }else{
              this.$router.push({ path: `/step` + step + `/${this.data.id}` });
            }
        },

        prev(tunnelConstructionMethod, step) {
            if (tunnelConstructionMethod == TUNNEL_CONSTRUCTION.NATM)
                this.$router.push({ path: `/step` + step + `/${this.data.id}` });
            else this.$router.push({ path: `/step` + step + `TBM/${this.data.id}` });
        },
        save() {
          // var regexp = /^[0-9-.]*$/;
          // var target1 = this.data.faceMappingStrength.orientationJoint1Rating;
          // var target2 = this.data.faceMappingStrength.orientationJoint2Rating;
          // var target3 = this.data.faceMappingStrength.orientationJoint3Rating;
          // var target4 = this.data.faceMappingStrength.orientationJoint4Rating;
          // var target5 = this.data.faceMappingStrength.orientationRandomJointRating;
          //
          // var param = {};
          // param.isShow = true;

          // if( !regexp.test(target1) && target1 !='') {
          // 	param.msg = 'Joint1 Rating을 올바르게 입력하세요.';
          //   this.alert(param);
          // 	return;
          // }
          // if( !regexp.test(target2) && target2 !='') {
          //   param.msg = 'Joint2 Rating을 올바르게 입력하세요.';
          //   this.alert(param);
          // 	return;
          // }
          // if( !regexp.test(target3) && target3 !='') {
          //   param.msg = 'Joint3 Rating을 올바르게 입력하세요.';
          //   this.alert(param);
          // 	return;
          // }
          // if( !regexp.test(target4) && target4 !='') {
          //   param.msg = 'Joint4 Rating을 올바르게 입력하세요.';
          //   this.alert(param);
          // 	return;
          // }
          // if( !regexp.test(target5) ) {
          //   param.msg = 'Random Joint	Rating을 올바르게 입력하세요.';
          //   this.alert(param);
          // 	return;
          // }

          var callbackParam = {};
          this.confirmParam.msg = '저장하시겠습니까?';
          this.confirmParam.isShow = true;
          this.confirmParam.callbackParam = callbackParam;
        },
        confirmCallback(callbackParam) {
          this.showLoading();
          var _that = "";
          this.data.faceMappingStrength.groundWaterRatio = "";
          $.each(this.groundWaterRatioList,function(){
              _that += _that == "" ? this : ","+ this;
          });
          this.data.faceMappingStrength.groundWaterRatio = _that;

          var param = this.data.faceMappingStrength;
          param.faceMappingSectionList = this.data.faceMappingSectionList;

          FacemappingApi.postStrength(param).then(res => {
              this.hideLoading();
              var param = {};
              param.isShow = true;
              param.msg = '저장 되었습니다.';
              this.alert(param);
              this.$router.push({
                  name: 'List'
              });
          });
        },
        codeSettign(code) {
          var that = this;
            CodeApi.subCodeList(code, 2).then(res => {
                that.rockNameList = res.content;
            });
        },
        changeRockName(name){
          if(name != '014004') this.data.faceMappingStrength.rockNameEtc = '';
        },
        changeSpacingOfJoint(){
          var cnt = 0;
          var spacingJoinScore = 0
          $.each($(".spacing_joint_area"),function(){
            if($(this).is(':checked')){
              spacingJoinScore +=Number($(this).data('key'));
              cnt ++;
            }
          })
          var res = Number(spacingJoinScore) / Number(cnt);
          this.data.faceMappingStrength.spacingJoinScore = cnt != 0 ? Math.floor(res*10)/10 : 0
          this.countRmrScore();
        },
        changeConditionOfJoint(){
          var classArray =["persistence_area" , "aperture_area" , "roughness_area" , "filling_area" , "strength_area"]
          var sum = 0;
          $.each(classArray , function(){
            var cnt = 0;
            var score = 0;
            var res = 0;
            $.each($("."+this),function(){
              if($(this).is(':checked')){
                score +=Number($(this).data('key'));
                cnt ++;
                res = Number(score) / Number(cnt) ;
              }
            })
             sum += res;
          });
          this.data.faceMappingStrength.conditionJoinScore = sum != 0 ? Math.floor(sum*10)/10 : 0;
          this.countRmrScore();
        },
        countRmrScore(){
          var rmr = 0
          if(this.data.faceMappingStrength != null){
             rmr = Number(this.data.faceMappingStrength.conditionJoinScore)+Number(this.data.faceMappingStrength.groundWaterRatioScore)+Number(this.data.faceMappingStrength.orientationScore)+Number(this.data.faceMappingStrength.rqdScore)+Number(this.data.faceMappingStrength.spacingJoinScore)+Number(this.data.faceMappingStrength.strengthIntackRockMaterialScore)
          }
          this.rmrScore = rmr != 0 ?  Math.floor(rmr*10)/10 : 0;
        },
        resetSpacingOfJoint(){
          this.data.faceMappingSectionList[0].spacingJoint = '';
          this.data.faceMappingSectionList[1].spacingJoint = '';
          this.data.faceMappingSectionList[2].spacingJoint = '';
          this.data.faceMappingSectionList[3].spacingJoint = '';
          this.data.faceMappingSectionList[4].spacingJoint = '';
          $(".spacing_joint_area").prop("checked", false);
          this.changeSpacingOfJoint();
        },
        resetPersistence(){
          this.data.faceMappingSectionList[0].persitence = '';
          this.data.faceMappingSectionList[1].persitence = '';
          this.data.faceMappingSectionList[2].persitence = '';
          this.data.faceMappingSectionList[3].persitence = '';
          this.data.faceMappingSectionList[4].persitence = '';
          $(".persistence_area").prop("checked", false);
          this.changeConditionOfJoint();
        },
        resetAperture(){
          this.data.faceMappingSectionList[0].aperture = '';
          this.data.faceMappingSectionList[1].aperture = '';
          this.data.faceMappingSectionList[2].aperture = '';
          this.data.faceMappingSectionList[3].aperture = '';
          this.data.faceMappingSectionList[4].aperture = '';
          $(".aperture_area").prop("checked", false);
          this.changeConditionOfJoint();
        },
        resetRoughness(){
          this.data.faceMappingSectionList[0].roughness = '';
          this.data.faceMappingSectionList[1].roughness = '';
          this.data.faceMappingSectionList[2].roughness = '';
          this.data.faceMappingSectionList[3].roughness = '';
          this.data.faceMappingSectionList[4].roughness = '';
          $(".roughness_area").prop("checked", false);
          this.changeConditionOfJoint();
        },
        resetFilling(){
          this.data.faceMappingSectionList[0].inFilling = '';
          this.data.faceMappingSectionList[1].inFilling = '';
          this.data.faceMappingSectionList[2].inFilling = '';
          this.data.faceMappingSectionList[3].inFilling = '';
          this.data.faceMappingSectionList[4].inFilling = '';
          $(".filling_area").prop("checked", false);
          this.changeConditionOfJoint();
        },
        resetStrength(){
          this.data.faceMappingSectionList[0].wallStrength = '';
          this.data.faceMappingSectionList[1].wallStrength = '';
          this.data.faceMappingSectionList[2].wallStrength = '';
          this.data.faceMappingSectionList[3].wallStrength = '';
          this.data.faceMappingSectionList[4].wallStrength = '';
          $(".strength_area").prop("checked", false);
          this.changeConditionOfJoint();
        }
    }
};
/*
#wrap > div {
    height: inherit;
}
*/
</script>
